"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const get_display_image_url_1 = require("./get-display-image-url");
const get_display_final_image_url_1 = require("./get-display-final-image-url");
const get_is_tab_fields_disabled_1 = require("./get-is-tab-fields-disabled");
const get_is_mobile_tab_1 = require("./get-is-mobile-tab");
const get_display_alternative_text_1 = require("./get-display-alternative-text");
const get_image_properties_validation_state_1 = require("./get-image-properties-validation-state");
function getters() {
    return {
        getDisplayImageUrl: get_display_image_url_1.getDisplayImageUrl(),
        getDisplayFinalImageUrl: get_display_final_image_url_1.getDisplayFinalImageUrl(),
        getIsMobileTab: get_is_mobile_tab_1.getIsMobileTab(),
        getIsTabFieldsDisabled: get_is_tab_fields_disabled_1.getIsTabFieldsDisabled(),
        getDisplayAlternativeText: get_display_alternative_text_1.getDisplayAlternativeText(),
        getImagePropertiesValidationState: get_image_properties_validation_state_1.getImagePropertiesValidationState(),
    };
}
exports.getters = getters;
//# sourceMappingURL=getters.js.map